import { useEffect } from 'react';
import AppRouter from './app/routes/AppRouter';
import { useAuthStore } from './app/store/authStore';
import { Toaster } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@/components/theme-provider';


// Create a client
const queryClient = new QueryClient();

function App(): JSX.Element {
  // Initialize auth state from storage
  useEffect(() => {
    // Get the auth store state and actions
    const { token, user, fetchUserProfileAction } = useAuthStore.getState();
    
    // If we have a token in localStorage but not in the store, set it
    const storedToken = localStorage.getItem('authToken');
    if (storedToken && !token) {
      // Set both token and isAuthenticated to ensure proper state
      useAuthStore.setState({ 
        token: storedToken, 
        isAuthenticated: true 
      });
    }
    
    // Always re-fetch user profile on app load when authenticated
    // This ensures userOrgId is up-to-date from user preferences
    if (token || storedToken) {
      console.log('App: Authenticated, refreshing user profile and org preferences...');
      fetchUserProfileAction()
        .then(() => console.log('User profile successfully fetched on app load'))
        .catch(err => console.error('Failed to fetch user profile on app load:', err));
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AppRouter />
        <Toaster position="bottom-left" />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
